//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSearch1, useSearch2 } from './ACS_BASIC_03_QUERY';
import ACS_BASIC_03 from './ACS_BASIC_03';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
//#endregion

function ACS_BASIC_03F(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);
  const [statData, setStatData] = useState(null);
  const [accidentRateData, setAccidentRateData] = useState(null);

  const { validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (data) => {
      setStatData(data);
    },
  });

  // 재해율 조회
  const { refetch: Search2 } = useSearch2({
    onSuccess: (data) => {
      setAccidentRateData(data);
    },
  });

  const SearchLogic1 = async () => {
    if (!validateSelection()) return;
    await Search1();
    await Search2();
  };

  useEffect(() => {
    if (!props.searchClick3) return;
    if (!validateSelection()) {
      props.setSearchClick3?.(false);
      return;
    }
    SearchLogic1();
    props.setSearchClick3?.(false);
  }, [props.searchClick3]);

  const searchYear = searchInfo?.year || '';

  return (
    <div className="wrap" style={{ minHeight: 0, overflowY: 'auto' }}>
      <ACS_BASIC_03
        statData={statData}
        searchYear={searchYear}
        accidentRateData={accidentRateData}
      />
    </div>
  );
}

export default ACS_BASIC_03F;
